export default "__VITE_ASSET__CpzU$lre__"